<div *ngIf="isJobCardModalOpen" class="overlay">
  <div
    #jobCardModal
    *ngIf="isJobCardModalOpen"
    class="job-card-modal"
    id="job-card"
    tabindex="-1"
    role="dialog"
    aria-hidden="true">
    <div class="modal-xl">
      <div class="modal-content pb-0">
        <div class="modal-header bg-color">
          <h5 class="modal-title">Job Board Card</h5>
          <button
            type="button"
            (click)="handleClose(); $event.preventDefault()"
            class="close"
            data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="grid-container">
            <div class="item1">
              <div class="profile-section">
                <div>
                  <h5>Owner|Facility</h5>
                  <p
                    *ngIf="
                      selectedRow?.potentialJobDetail?.owner?.name || selectedRow?.potentialJobDetail?.facility?.name
                    ">
                    {{ selectedRow?.potentialJobDetail?.owner?.name }} |
                    {{ selectedRow?.potentialJobDetail?.facility?.name }}
                  </p>
                </div>
              </div>
            </div>
            <div class="item2">
              <div class="profile-section">
                <div>
                  <h5>Job Number</h5>
                  <p>{{ selectedRow.jobNumber }}</p>
                </div>
              </div>
            </div>
            <div class="item3">
              <div class="profile-section">
                <div class="checkbox-item">
                  <input
                    type="checkbox"
                    style="width: 20px; height: 20px"
                    [checked]="selectedRow.isOnJobBoard"
                    (change)="toggleJobOnJobBoard($event)"
                    #is_on_job_board
                    name=""
                    id="jobBoardCard" />
                  <label for="jobBoardCard">Add to Job Board</label>
                </div>
              </div>
            </div>
            <div class="item4">
              <div class="profile-section">
                <div class="checkbox-item">
                  <input
                    type="checkbox"
                    style="width: 20px; height: 20px"
                    [checked]="selectedRow.isSeparateOnJobBoard"
                    (change)="toggleJobSeparateOnJobBoard($event)"
                    #is_separate_on_job_board
                    name=""
                    id="separateJobBoardCard" />
                  <label for="separateJobBoardCard">Create Separate Card</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            (click)="handleClose(); $event.preventDefault()"
            type="button"
            class="btn btn-primary mb-3 button-eh"
            #closebutton
            data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
